<template>
  <main class="main">
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <section class="basket">
      <div class="container">
        <h1 class="basket__title title center mb">Корзина</h1>
        <div v-show="hasCart" class="basket__row">
          <div class="basket__left">
            <div class="basket-promo">
              <button
                v-if="!promoOpen && !promoPartner"
                type="button"
                class="basket-promo__toggle"
                @click="promoOpen = true"
              >
                Укажите промокод / код партнёра
              </button>

              <div v-else-if="promoPartner" class="basket-promo__applied">
                <span>Промокод: <b>{{ promoPartner.code }}</b> ✓</span>
                <button type="button" class="basket-promo__remove" @click="removePromo">
                  убрать
                </button>
              </div>

              <form v-else class="basket-promo__form" @submit.prevent="applyPromo">
                <input
                  v-model="promoInput"
                  type="text"
                  class="basket-promo__input"
                  placeholder="Промокод"
                  autocomplete="off"
                />
                <button type="submit" class="basket-promo__apply" :disabled="promoPending">
                  Применить
                </button>
              </form>
              <div v-if="promoError" class="basket-promo__error">{{ promoError }}</div>
            </div>

            <BasketProducts
              title="Корзина"
              :items="products"
              @delete="deleteProduct"
            />
            <div class="checkout">
              <div class="checkout__delivery checkout-delivery">
                <div class="checkout-delivery__title">Способ доставки</div>

                <div class="checkout-delivery__info">
                  <Select
                    @change="selectedDelivery = $event"
                    :options="deliveryOptions"
                  />
                </div>
                <div
                  class="checkout-delivery__info"
                  v-if="selectedDelivery.id !== 1"
                >
                  <!--                                    <div class="checkout-delivery__info-title">Адрес</div>-->
                  <div class="checkout-delivery__info-descr">
                    <Input
                      v-model="address"
                      @input="test"
                      placeholder="Адрес"
                      v-if="selectedDelivery.id === 3"
                    />
                    <span v-else>{{ address }}</span>
                  </div>
                </div>

                <!-- <div class="checkout-delivery__dates">
                                                  <div v-for="(itemDelivery, i) in basketDeliveryItemsViews" :key="i" class="checkout-delivery__date">
                                                    <div class="checkout-delivery__date-title">{{ itemDelivery.delivery }}</div>
                                                    <div class="checkout-delivery__date-items">
                                                      <div v-for="(photo, i) in itemDelivery.items" :key="i" class="checkout-delivery__date-items-product">
                                                        <NuxtLink to="#"><img :src="photo.img" alt=""></NuxtLink>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div> -->
              </div>
              <div
                id="sdek-delivery"
                style="height: 500px"
                v-show="selectedDelivery.id === 2"
              ></div>

              <div class="checkout__row">
                <div class="checkout__payments checkout-payments">
                  <div class="checkout-payments__title">Способ оплаты</div>
                  <!-- <div class="checkout-payments__edit">
                                                        Изменить
                                                      </div>
                                                      <div class="checkout-payments__method"><IconDef name="card-mir"></IconDef> MIR ..9450</div> -->

                  <Select
                    :options="payments"
                    @change="selectedPayment = $event"
                    name="payment-select"
                  />
                </div>

                <div class="checkout__payments checkout-profile">
                  <div class="checkout-profile__title">Мои данные</div>
                  <!--                                    <div class="checkout-profile__edit">-->
                  <!--                                        Изменить-->
                  <!--                                    </div>-->
                  <div class="checkout-profile__method">
                    <!--                                        <IconDef name="profile"></IconDef>-->
                    <div>
                      <div class="checkout-delivery__info">
                        <Input
                          v-model="profile.phone"
                          placeholder="Номер телефона"
                        />
                      </div>
                      <div class="checkout-delivery__info">
                        <Input v-model="profile.name" placeholder="Имя" />
                      </div>
                      <div class="checkout-delivery__info">
                        <Input v-model="profile.email" placeholder="Почта" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="basket__right">
            <div class="basket-total">
              <div class="basket-total__header">
                Итого <span>{{ totalPrice }}₽</span>
              </div>
              <div class="basket-total__items-basket">
                <div>Товары, {{ totalCount }} шт.</div>
                <span>{{ productsTotalPrice }} ₽</span>
              </div>
              <!--                            <div v-if="totalDiscount" class="basket-total__items-basket">-->
              <!--                                <div>Скидка</div>-->
              <!--                                <span>{{ totalDiscount }} ₽</span>-->
              <!--                            </div>-->
              <!--                            <div class="basket-total__delivery">Адрес доставки: {{address}}</div>-->
              <div class="basket-total__delivery-adsress">
                Доставка: {{ selectedDelivery.name }}
                <template v-if="sdekInfo">
                  <b v-if="productsTotalPrice >= 25000">
                    Бесплатно от 25 000
                  </b>
                  <b v-else>{{ sdekInfo.tariff.delivery_sum }}₽</b>
                </template>
              </div>
              <div v-if="useBonuses > 0">
                Скидка за бонусы: <b>{{ bonusesDiscount }}₽</b>
              </div>
              <div class="basket-total__delivery-adsress">
                Адрес: {{ address }}
              </div>
              <!--                            <div class="basket-total__delivery">Дата доставки: <span>24 сентября</span></div>-->
              <div class="basket-total__payment">
                Оплата: <span>{{ selectedPayment.name }}</span>
              </div>
              <div class="basket-total__link">
                <NuxtLink>
                  <Button
                    title="Заказать"
                    btnClass="full-dark-btn"
                    @click.prevent="order"
                  />
                </NuxtLink>
              </div>
              <Bonuses v-if="user" @use="useBonuses = $event" />
              <div class="basket-total__agreement">
                <Checkbox
                  label="Я соглашаюсь с <a href='#'>политикой конфиденциальности</a>"
                  :isCheck="true"
                  name="agreement_politic"
                />
              </div>
            </div>
            <!--                        <div class="basket-split" v-show="selectedPayment.id === 1"></div>-->
          </div>
        </div>
        <div v-show="!hasCart" class="basket__empty">
          <h2 class="basket__empty-title title center">В корзине пока пусто</h2>
          <div class="basket__empty-subtitle subtitle center">
            Загляните на главную, чтобы выбрать товары или найдите нужное в
            поиске
          </div>
          <NuxtLink class="basket__empty-btn full-dark-btn" to="/"
            >Перейти на главную
          </NuxtLink>
        </div>
      </div>
    </section>
  </main>
</template>

<script setup lang="ts">
import { Product } from "~/api/Product";

const yaLoaded = ref(false);
const sdekLoaded = ref(false);
useHead({
  title: "Корзина",
  meta: [
    { name: "description", content: "Корзина" },
    { name: "keywords", content: "Корзина" },
  ],
});
useHead(
  {
    script: [
      {
        src: "https://pay.yandex.ru/sdk/v1/pay.js",
        async: true,
        onload: () => (yaLoaded.value = true),
      },
      {
        src: "https://cdn.jsdelivr.net/npm/@cdek-it/widget@3",
        async: true,
        onload: () => (sdekLoaded.value = true),
      },
    ],
  },
  { mode: "client" },
);

import Select from "~/components/UI/Form/Select.vue";
import Checkbox from "~/components/UI/btn/Checkbox.vue";
import Button from "~/components/UI/btn/Button.vue";
import Breadcrumbs from "~/components/Section/Breadcrumbs.vue";
import BasketProducts from "~/components/Section/BasketProducts.vue";
import Contacts from "~/components/Section/Contacts.vue";
import { CartHelper } from "~/helpers/CartHelper";
import type { BasketItemInterface } from "~/interfaces/BasketItemInterface";
import type { Sdek } from "~/interfaces/Sdek";
import type { SdekTariff } from "~/interfaces/SdekTariff";
import type { SdekLocation } from "~/interfaces/SdekLocation";
import Input from "~/components/UI/inputs/Input.vue";
import { Order } from "~/api/Order";
import { User } from "~/dto/User";
import { UserService } from "~/services/UserService";
import Bonuses from "~/components/Section/Basket/Bonuses.vue";
import Footer from "~/components/System/Footer.vue";
import { Cart as CartApi } from "~/api/Cart";
import { CartService } from "~/services/CartService";
import { ProductItem } from "~/api/ProductItem";
import type { ProductItemInterface } from "~/api/ProductItem";

const breadcrumbs = ref([
  {
    title: "Главная",
    url: "/",
  },
  {
    title: "Корзина",
  },
]);

const products = ref<Array<BasketItemInterface>>([]);
const productsTotalPrice = computed(() => {
  return products.value.reduce((prev, el) => prev + el.price * el.count, 0);
});

const totalPriceWithoutDiscounts = computed(() => {
  let price = productsTotalPrice.value;
  if (sdekInfo.value && price < 25000)
    price += sdekInfo.value.tariff.delivery_sum;

  return price;
});
const useBonuses = ref(0);
const bonusesDiscount = computed(() => {
  if (totalPriceWithoutDiscounts.value === 0 || useBonuses.value === 0)
    return 0;
  let bonuses = useBonuses.value;
  if (bonuses > totalPriceWithoutDiscounts.value / 2) {
    bonuses = Math.ceil(totalPriceWithoutDiscounts.value / 2);
  }

  return bonuses;
});
const totalPrice = computed(() => {
  return totalPriceWithoutDiscounts.value - bonusesDiscount.value;
});

const SDEK = 2;
const totalCount = computed(() => {
  return products.value.reduce((prev, el) => prev + el.count, 0);
});
const hasCart = ref(false);
const deliveryOptions = [
  {
    name: "Самовывоз",
    id: 1,
  },
  {
    name: "СДЭК",
    id: 2,
  },
  {
    name: "Курьером по Москве",
    id: 3,
  },
];
const selectedDelivery = ref<Object>(deliveryOptions[0]);
const sdekInfo = ref<Sdek | null>(null);
const address = ref("");
const profile = ref({
  name: "",
  phone: "",
  email: "",
});

const test = () => {
  console.log(address);
};

const payments = computed(() => {
  const arr: Array<Object> = [
    {
      id: 1,
      name: "Картой",
    },
  ];
  if (selectedDelivery.value.id === 1) {
    arr.push({
      id: 0,
      name: "В шоуруме",
    });
  }

  return arr;
});
const selectedPayment = ref<Object>(payments.value[0]);

// Once logged in, mergeLocalIntoServer() has already folded and cleared the
// localStorage cart — from then on the server cart (shared across every
// poddomain) is the only source of truth, so this page has to read from it
// too rather than from the now-empty local one.
// ── Промокод / код партнёра на всю корзину (ТЗ-017).
const promoOpen = ref(false);
const promoInput = ref("");
const promoPending = ref(false);
const promoError = ref("");
const promoPartner = ref<{ code: string; slug: string; name: string } | null>(null);

async function applyPromo() {
  const code = promoInput.value.trim();
  if (!code) return;
  promoPending.value = true;
  promoError.value = "";
  const partner = await CartService.getInstance().applyPromoCode(code);
  promoPending.value = false;
  if (!partner) {
    promoError.value = "Код не найден или неактивен";
    return;
  }
  promoPartner.value = partner;
  promoOpen.value = false;
  promoInput.value = "";
}

async function removePromo() {
  await CartService.getInstance().removePromoCode();
  promoPartner.value = null;
  promoOpen.value = false;
  promoError.value = "";
}

async function loadPromo() {
  const code = await CartService.getInstance().getPromoCode();
  if (code) {
    const partner = await CartService.getInstance().applyPromoCode(code);
    if (partner) promoPartner.value = partner;
  }
}

const isServerCart = ref(false);
// Keyed by `${productId}_${itemId ?? ''}_${vibeId ?? ''}` — a product can have
// several cart lines (per size/item and per vibe it was added from).
const serverItemIdByLine: Record<string, number> = {};

function lineKey(productId: number, itemId: number | null, vibeId: number | null): string {
  return `${productId}_${itemId ?? ""}_${vibeId ?? ""}`;
}

async function loadCart() {
  const authedUser = await UserService.getInstance().getCurrent();
  isServerCart.value = !!authedUser;

  let ids: number[];
  let serverItems: Array<{
    id: number;
    productId: number;
    itemId: number | null;
    vibeId: number | null;
    attributeLabel: string | null;
    attributeValue: string | null;
    quantity: number;
  }> = [];

  if (isServerCart.value) {
    try {
      const data = await CartApi.get();
      serverItems = data?.items ?? [];
    } catch {
      serverItems = [];
    }
    ids = [...new Set(serverItems.map((el) => el.productId))];
  } else {
    const cart = CartHelper.getCart();
    ids = [...new Set(cart.value.items.map((el) => el.id))];
  }

  if (ids.length > 0) hasCart.value = true;

  // Items may have their own price/discount (see ProductCard.vue) — resolve
  // them the same way here so the basket total stays correct per size, not
  // just per product.
  const itemsByProduct: Record<number, ProductItemInterface[]> = {};
  await Promise.all(
    ids.map(async (id) => {
      itemsByProduct[id] = await ProductItem.getByProduct(id).catch(() => []);
    }),
  );

  const data = await Product.getVariants(ids);
  if (isServerCart.value) {
    serverItems.forEach((line) => {
      const product = data.products.find((p) => p.id === line.productId);
      if (!product) return;
      const item = line.itemId
        ? itemsByProduct[line.productId]?.find((i) => i.id === line.itemId)
        : null;

      products.value.push({
        id: product.id,
        variantId: product.id,
        itemId: line.itemId,
        vibeId: line.vibeId ?? null,
        price: item?.price?.retailPrice ?? product.price,
        count: line.quantity,
        name: product.name,
        size: line.attributeValue ?? "",
        img: product.mainImage?.path,
        amount: item?.stock ?? product.amount,
        params: product.params
          .filter((p) => !p.selectable)
          .map((p) => ({ name: p.name, value: p.toString() })),
        type: product.type,
      });
      serverItemIdByLine[lineKey(line.productId, line.itemId, line.vibeId ?? null)] = line.id;
    });
  } else {
    const cart = CartHelper.getCart();
    data.products.forEach((product) => {
      const param = product.params.find((p) => p.selectable);
      const items = cart.value.items.filter((el) => el.id === product.id);
      items.forEach((cartItem) => {
        const variant = product.getVariant(cartItem.variantId);
        const legacyValue = param?.getVariantValue(cartItem.variantId)?.value || "";
        const item = cartItem.itemId
          ? itemsByProduct[product.id]?.find((i) => i.id === cartItem.itemId)
          : null;

        products.value.push({
          id: product.id,
          variantId: variant.id,
          itemId: cartItem.itemId,
          vibeId: cartItem.vibeId ?? null,
          price: item?.price?.retailPrice ?? product.price,
          count: cartItem.count,
          name: product.name,
          size: cartItem.attributeValue || legacyValue,
          img: product.mainImage?.path,
          amount: item?.stock ?? product.amount,
          params: product.params
            .filter((p) => !p.selectable)
            .map((p) => {
              return {
                name: p.name,
                value: p.toString(),
              };
            }),
          type: product.type,
        });
      });
    });
  }

  if (sdekLoaded.value) loadSdek();
  else watch(sdekLoaded, loadSdek);
}

function loadSdek() {
  if (!document.getElementById("sdek-delivery")) {
    setTimeout(loadSdek, 100);
    return;
  }
  const cart = CartHelper.getCart();

  const goods = [];
  for (let i = 1; i <= cart.value.items.length; i++) {
    goods.push({
      width: 20,
      height: 11,
      length: 21,
      weight: 1000,
    });
  }
  new window.CDEKWidget({
    from: {
      city: "Москва",
      address: "Москва, Старопетровский проезд, 8",
      country_code: "RU",
      postal_code: 125130,
      code: 860,
    },
    root: "sdek-delivery",
    apiKey: "aa9ab3e4-0e36-446b-a26f-4bc330867cae",
    servicePath: "https://blvkaapi.maxsharun.ru/api/sdek/offices",
    defaultLocation: "Москва",
    debug: true,
    lang: "rus",
    currency: "RUB",
    goods,
    // onReady(...params) {
    //     console.log(params);
    // },
    // onCalculate(...params) {
    //     console.log(params);
    // },
    onChoose(type: string, tariff: SdekTariff, location: SdekLocation) {
      sdekInfo.value = {
        type,
        tariff,
        location,
      };
      address.value = [
        location.postal_code,
        location.region,
        location.city,
        location.address,
      ].join(", ");
    },
  });
}

function deleteProduct(variantId: number, itemId: number | null = null, vibeId: number | null = null) {
  if (isServerCart.value) {
    const cartItemId = serverItemIdByLine[lineKey(variantId, itemId, vibeId)];
    if (cartItemId) CartApi.remove(cartItemId).catch(() => {});
  } else {
    const cart = CartHelper.getCart();
    cart.value.deleteProduct(variantId, itemId, vibeId);
  }

  const i = products.value.findIndex(
    (el) =>
      el.variantId === variantId &&
      (el.itemId ?? null) === (itemId ?? null) &&
      (el.vibeId ?? null) === (vibeId ?? null),
  );
  if (~i) products.value.splice(i, 1);
  CartService.getInstance().refresh();
}

async function order() {
  const order = await makeOrder();
  location.href = order.link;
}

async function makeOrder() {
  if (!profile.value.name) {
    alert("Заполните имя");
    throw "";
  }
  if (!profile.value.phone) {
    alert("Заполните телефон");
    throw "";
  }
  if (selectedDelivery.value.id === SDEK && !sdekInfo.value) {
    alert("Выберите адрес доставки СДЭК");
    throw "";
  }
  if (selectedDelivery.value.id === 3 && !address.value) {
    alert("Заполните адрес");
    throw "";
  }

  const formData = new FormData();
  formData.append("name", profile.value.name);
  formData.append("phone", profile.value.phone);
  if (profile.value.email) formData.append("email", profile.value.email);
  // Line-based позиции (ТЗ-017a): каждая строка корзины со своими item_id/vibe_id.
  CartService.getInstance().appendOrderPositions(
    formData,
    products.value.map((p: BasketItemInterface) => ({
      productId: p.variantId,
      itemId: p.itemId ?? null,
      vibeId: p.vibeId ?? null,
      count: p.count,
      price: p.price,
    })),
  );
  if (promoPartner.value?.code) formData.append("partner_code", promoPartner.value.code);
  formData.append("payment", selectedPayment.value.id);
  formData.append("delivery", selectedDelivery.value.id);
  formData.append("address[address]", address.value);
  if (selectedDelivery.value.id === SDEK && sdekInfo.value) {
    formData.append(
      "address[tariff]",
      String(sdekInfo.value.tariff.tariff_code),
    );
    if (sdekInfo.value.location.city_code) {
      formData.append(
        "address[toLocation][code]",
        String(sdekInfo.value.location.city_code),
      );
    } else {
      formData.append(
        "address[toLocation][address]",
        sdekInfo.value.location.formatted,
      );
      formData.append("address[toLocation][country_code]", "RU");
    }
  }
  formData.append("bonuses", String(bonusesDiscount.value));

  const data = await Order.createOrder(formData);
  if (isServerCart.value) {
    await Promise.all(
      Object.values(serverItemIdByLine).map((id) => CartApi.remove(id).catch(() => {})),
    );
  } else {
    CartHelper.getCart().value.clear();
  }
  hasCart.value = false;
  products.value = [];
  CartService.getInstance().refresh();
  return data;
}

let paymentSession: Object | null = null;
watch(totalPrice, () => {
  if (paymentSession) {
    paymentSession.update(async function () {
      return {
        totalAmount: totalPrice.value,
      };
    });
  }
});
watch(selectedDelivery, () => (sdekInfo.value = null));

function initYandex() {
  return;
  if (!document.querySelector(".basket-split")) {
    setTimeout(initYandex, 100);
    return;
  }
  const YaPay = window.YaPay;

  const paymentData = {
    //        env: YaPay.PaymentEnv.Sandbox,
    version: 4,
    currencyCode: YaPay.CurrencyCode.Rub,
    merchantId: "e54f3101-6656-443f-bb03-50b7a9d53319",
    totalAmount: totalPrice.value,
    availablePaymentMethods: ["CARD", "SPLIT"],
  };

  async function onPayButtonClick() {
    const order = await makeOrder();
    location.href = order.link;
  }

  YaPay.createSession(paymentData, {
    onPayButtonClick: onPayButtonClick,
  }).then(function (ps: Object) {
    paymentSession = ps;
    window.paymentSession = ps;
    ps.mountWidget(document.querySelector(".basket-split"), {
      env: YaPay.PaymentEnv.Sandbox,
      widgetTheme: YaPay.WidgetTheme.Light,
      borderRadius: 20,
      padding: YaPay.WidgetPaddingType.Default,
      withOutline: false,
      widgetBackground: YaPay.WidgetBackgroundType.Default,
      hideWidgetHeader: false,
      widgetSize: YaPay.WidgetSize.Medium,
      widgetType: YaPay.WidgetType.BnplOffer,
    });
  });
}

const user = ref<User | null>();

onMounted(() => {
  if (process.client) {
    if (yaLoaded.value) initYandex();
    else watch(yaLoaded, initYandex);
    loadCart();
    loadPromo();

    UserService.getInstance()
      .getCurrent()
      .then((u) => (user.value = u));
  }
});
</script>

<style scoped lang="scss">
.basket-promo {
  margin-bottom: 1.6rem;

  &__toggle {
    background: none;
    border: none;
    padding: 0;
    font-size: 1.4rem;
    color: #1b1918;
    text-decoration: underline;
    text-underline-offset: 3px;
    cursor: pointer;
  }

  &__form {
    display: flex;
    gap: 0.8rem;
  }

  &__input {
    flex: 1;
    max-width: 24rem;
    height: 4.4rem;
    padding: 0 1.2rem;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    font-size: 1.4rem;
  }

  &__apply {
    height: 4.4rem;
    padding: 0 2rem;
    border: none;
    border-radius: 4px;
    background: #1b1918;
    color: #fff;
    font-size: 1.4rem;
    cursor: pointer;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  &__applied {
    display: flex;
    align-items: center;
    gap: 1.2rem;
    font-size: 1.4rem;
  }

  &__remove {
    background: none;
    border: none;
    padding: 0;
    font-size: 1.3rem;
    color: #999;
    text-decoration: underline;
    cursor: pointer;
  }

  &__error {
    margin-top: 0.6rem;
    font-size: 1.3rem;
    color: #b00;
  }
}
</style>
